import React from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import AreaDropdown from 'components/dropdowns/AreaDropdown';
import UserDropdown from 'components/dropdowns/UserDropdown';
import ProductStartsWithDropdown from 'components/dropdowns/ProductStartsWithDropdown';

function StockRequestFilter({ filter, handleChange, handleSubmit }) {
  const { t } = useTranslation();

  return (
    <Card className="mb-3">
      <Card.Body>
        <Row className="g-3">
          <Col md={3}>
            <Form.Label>{t('filterArea')}</Form.Label>
            <AreaDropdown
              selectedOptions={filter.area}
              handleChange={option => handleChange('area', option)}
              isMulti={false}
              isClearable
            />
          </Col>

          <Col md={3}>
            <Form.Label>{t('filterRequestedBy')}</Form.Label>
            <UserDropdown
              selectedOptions={filter.requestedBy}
              handleChange={option => handleChange('requestedBy', option)}
              isMulti={false}
              isClearable
            />
          </Col>

          <Col md={3}>
            <Form.Label>{t('filterEmplasCode')}</Form.Label>
            <ProductStartsWithDropdown
              field="productCode"
              value={filter.emplasCode}
              onSelect={product =>
                handleChange('emplasCode', product?.productCode ?? '')
              }
              placeholder={t('searchPlaceholder')}
            />
          </Col>

          <Col md={3}>
            <Form.Label>{t('filterSupplierCode')}</Form.Label>
            <ProductStartsWithDropdown
              field="supplierCode"
              value={filter.supplierCode}
              onSelect={product =>
                handleChange('supplierCode', product?.supplierCode ?? '')
              }
              placeholder={t('searchPlaceholder')}
            />
          </Col>
        </Row>

        <div className="pt-3">
          <Button type="button" onClick={handleSubmit}>
            {t('searchButton')}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}

StockRequestFilter.propTypes = {
  filter: PropTypes.object,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func
};

export default StockRequestFilter;
